import React, { useCallback } from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../common/list/FilterToggleGroup';

const invTyps = [
  { id: 1, value: '매출', label: '수금', color: 'primary' },
  { id: 2, value: '매입', label: '지급', color: 'secondary' },
];

// 구분 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
const CollectBuyStatusList = ({ filters, onFilters }) => {
  const handleFilterBillType = useCallback((value) => onFilters('searchInvTyp', value), [onFilters]);

  return (
    <FilterToggleRow>
      <FilterToggleGroup label="구분" options={invTyps} value={filters?.searchInvTyp} onChange={handleFilterBillType} />
    </FilterToggleRow>
  );
};

export default CollectBuyStatusList;
